module.exports = "/_next/static/images/icnEdu-a9a011abf43957378b7b2a2b53d6cdd9.png";